































import * as _ from 'lodash';
import $ from 'jquery';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Draggable } from 'draggable-vue-directive';
import { Guid } from 'guid-typescript';

import { mixins } from 'vue-class-component';
import { Language, VisitorType } from '../../types/Enum';
import { IPortfolioWindowReduced, IVueWindow } from '../../types/Interface';

import Shortcut from './Shortcut.vue';
import {
  Skills, AboutMe, Expertise, Experiences, Contact,
} from './windowContent';
import APortfolioWindow from './APortfolioWindow';


@Component({
  components: {
    Skills,
    AboutMe,
    Expertise,
    Experiences,
    Contact,
  },
  directives: {
    Draggable,
  },
})
export default class WindowProperties extends mixins(APortfolioWindow) {
  @Prop({ default: 'Explorateur de fichiers' }) readonly title!: string;

  @Prop({ default: () => Guid.create() }) readonly id!: Guid;

  private currentTab: any = 'Skills';

  private tabs:string[] = ['Skills', 'AboutMe', 'Expertise', 'Experiences'];

  private check: Function = (str: string) => (this.title === str)

  public mounted() {
    console.log('constructeur windows');
    this.draggableValue.handle = this.$refs[this.handleId];
    this.refWindowContent = this.$refs.windowcontent as Element;
  }

  private setVisitor(type: VisitorType): void {
  }
}
